




































import { getCompanyInfo } from '@/utils/getCompanyInfo';
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  createPhoneRecommendAb,
  dismissPhoneRecommend,
  PhoneRecommendationType,
} from '@/services/phoneRecommend';

@Component
export default class PhoneRecommendCard extends Vue {
  @Prop({ type: String, required: true }) readonly formId!: string;
  @Prop({ type: String, required: true }) readonly entry!: 'list' | 'editor';
  @Prop({ type: String, default: 'add_phone_step' })
  readonly recommendationType!: PhoneRecommendationType;
  // 禁用状态由后端根据当前实验草稿判定，不影响查看方案。
  @Prop({ type: Boolean, default: false }) readonly abCreateDisabled!: boolean;

  get isCopyRecommendation() {
    return this.recommendationType === 'optimize_phone_copy';
  }
  dismissed = false;
  creating = false;
  dismissing = false;
  observer: IntersectionObserver | null = null;

  get busy() {
    return this.creating || this.dismissing;
  }

  mounted() {
    // 卡片进入可视区域才记曝光；组件内只记一次，重复渲染不重复记录。
    this.observer = new IntersectionObserver((entries) => {
      if (this.observer && entries.some((item) => item.isIntersecting)) {
        this.report('form_phoneRecommend_view', '手机号推荐曝光', 'view');
        this.observer.disconnect();
        this.observer = null;
      }
    });
    this.observer.observe(this.$el);
  }

  beforeDestroy() {
    this.observer?.disconnect();
  }

  report(event: string, label: string, eventType = 'click') {
    const account: Record<string, unknown> = JSON.parse(
      localStorage.getItem('displayInfo') || '{}',
    );
    window?.gtagNew?.('event', event, {
      event_name: label,
      event_type: eventType,
      Company_id: getCompanyInfo().id,
      login_id: account.id,
      login_type: account.innerUserType,
      path_url: window.location.href,
      time: new Date(),
      popId: this.formId,
      recommendationType: this.recommendationType,
      entry: this.entry,
    });
  }

  async dismiss() {
    if (this.busy) return;
    this.dismissing = true;
    try {
      if (await dismissPhoneRecommend(this.formId, this.recommendationType)) {
        this.dismissed = true;
        this.report('form_phoneRecommend_dismiss', '忽略手机号推荐');
        this.$emit('dismissed');
      }
    } finally {
      this.dismissing = false;
    }
  }

  preview() {
    this.report('form_phoneRecommend_click', '查看手机号推荐方案');
    this.$emit('preview');
  }

  async createAb() {
    if (this.busy || this.abCreateDisabled) return;
    this.creating = true;
    this.report('form_phoneRecommend_createAB', '手机号推荐创建A/B');
    try {
      await createPhoneRecommendAb(this.formId, this.recommendationType);
      this.$router.push(`/wheel_of_fortune/abtest/${this.formId}`);
    } finally {
      this.creating = false;
    }
  }
}
